const countryRegions = require('../data/phone-regions')
const sharedCodes = [...new Set(countryRegions.map(item => item.code))].filter(code => countryRegions.filter(item => item.code === code).length > 1)
// A calling code can belong to several countries. Do not infer residence from it.
const regions = countryRegions.concat(sharedCodes.map(code => ({id:'shared-'+code,code,label:'共用区号 +'+code})))
const clean = value => String(value || '').trim().replace(/[\s()-]/g, '')
function normalizePhone(value) {
  const raw = clean(value)
  return /^\+861\d{10}$/.test(raw) ? raw.slice(3) : raw
}
function validPhone(value) {
  const raw = normalizePhone(value)
  if (/^1\d{10}$/.test(raw)) return true
  if (raw.startsWith('+86')) return false
  if (/^\+85[23]/.test(raw)) return /^\+85[23]\d{8}$/.test(raw)
  if (raw.startsWith('+886')) return /^\+8869\d{8}$/.test(raw)
  return /^\+[1-9]\d{6,14}$/.test(raw)
}
function splitPhone(value) {
  const raw = normalizePhone(value)
  if (!raw.startsWith('+')) return { index: 0, number: raw }
  const match = regions.map((region, index) => ({...region,index})).filter(r => raw.startsWith('+' + r.code)).sort((a,b) => b.code.length-a.code.length)[0]
  const sharedIndex = match ? regions.findIndex(item => item.id === 'shared-' + match.code) : -1
  return match ? { index: sharedIndex >= 0 ? sharedIndex : match.index, number: raw.slice(match.code.length + 1) } : { index: 0, number: raw }
}
function composePhone(value, code) {
  const raw = clean(value)
  if (!raw) return ''
  if (raw.startsWith('+')) return normalizePhone(raw)
  return code === '86' ? raw : '+' + code + (code === '886' ? raw.replace(/^0/, '') : raw)
}
module.exports = { regions, normalizePhone, validPhone, splitPhone, composePhone }
